module.exports = __webpack_public_path__ + "img/tuki_no.d33dd478.png";